import React from "react";

function ViewLabelwithDataLoader() {
  return (
    <div className=" flex flex-col items-start justify-center border-borderdark rounded-xl m-auto animate-pulse gap-y-2">
      <div className="h-3 rounded-full bg-gray-100  w-32"></div>
      <div className="h-4 rounded-full bg-gray-100  w-44"></div>
    </div>
  );
}

export default ViewLabelwithDataLoader;
